export default __webpack_public_path__ + "static/AFMUSCanadaBW-ae3020e0746dad816ee86c9da109a0a6.jpg";